import generateUri from "@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/generateUri";
import cdnRouter from "../../../constants/routers/cdn";

/**
 * Retourne l’URI de la route du cdn demandée.
 * @returns {string}
 */
export default function generateCdnUrl(param0) {
  return generateUri({
    router: cdnRouter,
    ...param0,
  });
}
